module.exports = __webpack_public_path__ + "static/img/94007C_2_3_R_20200529_fit.fe0374b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/94007C_2_3_R_20200529_fit.png
// module id = TnSq
// module chunks = 0